module.exports = __webpack_public_path__ + "img/CM-DJ-25-Nissan-Lifestyle.3d949e07.jpg";